/**
 * 測定結果管理ページ用のスクリプト
 */
if (is_route('daily_check_result.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        daily_check_event_set();
        //daily_check_item_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.daily_check_event_set = function() {

    // ボタンクリック時のバブリングを禁止
    $(document).on('click', '.daily_check_result-confirm-check', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });

    /*---- 検索条件変更時 ----*/

    // 測定日時（開始）変更時
    $(document).on('change', '#search-form-started_at', function () {
        let last_day = null;
        selected_date = $(this).val();
        set_end = $('#search-form-ended_at').val();
        if(set_end != ''){
            selected_date = new Date(selected_date);
            chk_date_over = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() + 31);
            chk_date = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate());
            set_end = new Date(set_end);
            yyyymmdd = new Date(set_end.getFullYear(),set_end.getMonth(),set_end.getDate());
            if(chk_date_over.getTime() < yyyymmdd.getTime()){
                yyyymmdd = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() + 31);
                last_day = yyyymmdd.getFullYear()+'/'+
                        ( "0"+( yyyymmdd.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd.getDate() ).slice(-2);
                $('#search-form-ended_at').val(last_day);
            }else if(chk_date.getTime() > yyyymmdd.getTime()){
                last_day = chk_date.getFullYear()+'/'+
                        ( "0"+( chk_date.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+chk_date.getDate() ).slice(-2);
                $('#search-form-ended_at').val(last_day);
            }
        }
    });

    // 測定日時（終了）変更時
    $(document).on('change', '#search-form-ended_at', function () {
        let last_day = null;
        selected_date = $(this).val();
        set_start = $('#search-form-started_at').val();
        if(set_start != ''){
            selected_date = new Date(selected_date);
            set_start = new Date(set_start);
            yyyymmdd = new Date(set_start.getFullYear(),set_start.getMonth(),set_start.getDate() + 31);
            yyyymmdd_2 = new Date(set_start.getFullYear(),set_start.getMonth(),set_start.getDate());
            if(selected_date.getTime() > yyyymmdd.getTime()){
                last_day = yyyymmdd.getFullYear()+'/'+
                        ( "0"+( yyyymmdd.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd.getDate() ).slice(-2);
                $('#search-form-ended_at').val(last_day);
            }else if(selected_date.getTime() < yyyymmdd_2.getTime()){
                last_day = yyyymmdd_2.getFullYear()+'/'+
                        ( "0"+( yyyymmdd_2.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd_2.getDate() ).slice(-2);
                $('#search-form-ended_at').val(last_day);
            }
        }
    });

    // グループ会社変更時
    $(document).on('change', '#search-form-holding_id', function () {
        var action = $('#search-form').attr('action').replace('/list', '');
        if($(this).val() == ''){
            location.href = action;
            return false;
        }
        let excutionData = [];
        excutionData.push('company_id', 'section_id', 'page');
        action = _request.create_affiliation_url(action, true, [{'name': 'holding_id', 'value': $(this).val()}], excutionData);
        location.href = action;
        return false;
    });

    // 会社変更時
    $(document).on('change', '#search-form-company_id', function () {
        var action = $('#search-form').attr('action').replace('/list', '');
        if($(this).val() == ''){
            location.href = action;
            return false;
        }
        let excutionData = [];
        excutionData.push('section_id', 'page');
        const dateError = $('#search-form-started_at-errors').find('.invalid-feedback').not('.copy');
        if (dateError.text().trim() !== '') {
            excutionData.push('started_at', 'ended_at');
        }
        action = _request.create_affiliation_url(action, true, [{'name': 'company_id', 'value': $(this).val()}], excutionData);
        location.href = action;
        return false;
    });

    // 営業所変更時
    $(document).on('change', '#search-form-section_id', function () {
        var action = $('#search-form').attr('action').replace('/list', '');
        if($(this).val() == ''){
            let urlString = new URL(location.href);
            urlString.searchParams.delete('section_id');
            location.href = urlString;
            return false;
        }
        let excutionData = [];
        const dateError = $('#search-form-started_at-errors').find('.invalid-feedback').not('.copy');
        if (dateError.text().trim() !== '') {
            excutionData.push('started_at', 'ended_at');
        }
        excutionData.push('section_id', 'page');
        action = _request.create_affiliation_url(action, true, [{'name': 'section_id', 'value': $(this).val()}], excutionData);
        location.href = action;
        return false;
    });

    /*---- 設定表示時 ----*/
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], true);
    });

    /*---- 設定保存時 ----*/
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    /*---- 詳細表示時 ----*/
    $(document).on('click', '[data-detail-modal]', function () {
        _modal.create(this, 'detail-modal', ['id']);
    });

    /*---- 削除確認時 ----*/
    $(document).on('click', '[data-delete-confirm-modal]', function () {
        _modal.create(this, 'delete-confirm-modal', ['id']);
    });

    /*---- 削除実行時 ----*/
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

    
    /*---- 確認時 ----*/

    // 確認時
    $(document).on('click', '.daily_check_result-confirm', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 対象ID取得
        let ids = ($(this).data('id') == null ? [] : [$(this).data('id')]);
        let holding_id = $(this).data('holding_id');
        let company_id = $(this).data('company_id');
        // 表示制御するコントロールを取得
        let btn = $(this);
        let chk = $('#daily_check_result-confirm'+$(this).data('id'));
        if (ids.length > 0) {
            _ajax.post(action, {'ids': ids, 'holding_id': holding_id, 'company_id': company_id}, function (response) {
                $(btn).hide();
                $(btn).parent("td").append('<span>'+response.user_name+'</span>');
                $(chk).remove();
                $(btn).closest('tr').find('.td-confirmed_time').text(response.confirmed_time);
                // 完了メッセージをセットする
                _complete.set(response);
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });    
        }
    });

    /*---- 一括確認チェックボックス操作時 ----*/

    // 一括のチェックボックスクリック時
    $(document).on('click', '#daily_check_result-all-confirm', function () {
        $(".daily_check_result-confirm-check").prop('checked', $(this).prop('checked'));
    });
    // 一覧のチェックボックスクリック時
    $(document).on('click', '.daily_check_result-confirm-check', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });
    // 一括・一覧のチェックボックス変更時
    $(document).on('change', '#daily_check_result-all-confirm, .daily_check_result-confirm-check', function () {
        // 一覧のチェック状態を判定し確認ボタンを有効化
        $('#daily_check_result-multi-confirm-button').prop('disabled', ($('.daily_check_result-confirm-check:checked').length == 0));
    });

    /*---- 一括確認クリック時 ----*/

    // 一括確認クリック時
    $(document).on('click', '#daily_check_result-multi-confirm-button', function () {
        var ids = [];
        $('.daily_check_result-confirm-check[name="ids[]"]:checked').map(function() {
            ids.push($(this).val());
        });
        if (ids.length > 0) {
            let holding_id = $('#daily_check_result-list-holding_id').val();
            let company_id = $('#daily_check_result-list-company_id').val();
            _modal.create_with_data(this, 'confirm-modal', {'ids': ids, 'holding_id': holding_id, 'company_id': company_id});    
        }
    });

    /*---- 一括確認処理 ----*/

    // 一括確認実行時
    $(document).on('click', '[data-multi-confirm-modal]', function () {
        _modal.submit(this, 'multi-confirm-modal', function(results) {
            _modal.hide('#daily_check_result-confirm-modal');
            $("#daily_check_result-all-confirm").trigger('change');
        });
    });


    /*---- 検索ボタン押下時 ----*/

    // 検索時
    $(document).on('click', '#search-form-action_search', function () {
        // コンテンツを読込
        load_contents(null, false);
    });

    /*---- 印刷ボタン押下時 ----*/

    // 印刷時
    $(document).on('click', '#search-form-action_print', function () {
        // 送信値を配列化
        let datas = $('#search-form').serializeArray();
        let action = extend_url_query($(this).data('action'));
        // BlobでPDFを別ウィンドウで表示
        _ajax.blob(action, datas, function (blob) {
            window.open(window.URL.createObjectURL(blob), '_blank');
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    /*---- CSVダウンロード時 ----*/

    /*----
    // CSVダウンロード時
    $(document).on('click', '#search-form-action_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // ポスト送信を実行
        post(action, datas);
    });
    ----*/

    // 初期表示時に選択状態とする
    $("#daily_check_result-all-confirm").trigger('change');
}


